import { defineComponent as _defineComponent } from 'vue'
import WizardStep from '../wizard/WizardStep.vue';
import { isNil, valueOrDefault } from '@/utils/misc';
import { AlertKPI } from '@/models/enums/AlertsEnums';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'EventCodesSelectionFormWizardStep',
  props: {
    hidden: { type: Boolean },
    kpi: null,
    value: null,
    title: null
  },
  emits: ["input", "enter"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: string[]): void;
  (e: 'enter'): void;
}), expose: any, slots: any, attrs: any }) {





const { t } = useI18n();

return { __sfc: true,emit, t, WizardStep, isNil, valueOrDefault }
}

})